import React, { useState, useEffect } from "react";
import { Tooltip, Button, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import {
  getDeviceGroups,
  getDeviceGroupSelectors,
} from "app/services/report_templates/deviceGroupService";

import DeviceGroupModal from "./DeviceGroupModal";

import CustomTable from "components/common/table/CustomTable";
import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { showErrorToast } from "utils/toast";

import { USER_ROLES } from "static/constants";
import { getCurrentUserRole } from "utils/currentUser.util";
import { EditOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import ExpandableChips from "components/common/expandable-chips/ExpandableChips";

const DeviceGroupsView = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [isDeleting, setIsDeleting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  // const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [selectorsData, setSelectorsData] = useState({});
  const { shouldRefetch } = useSelector((state) => state.device);

  const userRole = getCurrentUserRole();

  const fetchDeviceGroups = async () => {
    try {
      setIsLoading(true);

      const data = await getDeviceGroups();
      setDeviceGroups(data || []);
    } catch (error) {
      showErrorToast(error?.message ?? error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDeviceGroupSelectors = async () => {
    try {
      setIsLoading(true);

      const data = await getDeviceGroupSelectors();
      setSelectorsData(data || {});
    } catch (error) {
      showErrorToast(error?.message ?? error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDeviceGroups();
    fetchDeviceGroupSelectors();
  }, [shouldRefetch]); // eslint-disable-line react-hooks/exhaustive-deps

  // const deleteDeviceGroups = async () => {
  //   try {
  //     setIsDeleting(true);

  //     await deleteDeviceGroup(selectedRow?._id);
  //     await fetchDeviceGroups();
  //     showSnackBar("Device Group deleted successfully", false);
  //   } catch (error) {
  //     showSnackBar(error?.message ?? error);
  //   } finally {
  //     setIsDeleting(false);
  //     setSelectedRow(null);
  //     setShowConfirmModal(false);
  //   }
  // };

  const onCloseModal = () => {
    setShowEditModal(false);
    setIsEditMode(false);
    setSelectedRow(null);
  };

  // const onConfirmModalClose = () => {
  //   setShowConfirmModal(false);
  //   setSelectedRow(null);
  // };

  const columns = [
    { header: "Name", accessorKey: "name", type: "string", size: 10 },
    {
      header: "Devices",
      accessorKey: "devices",
      size: 750,
      Cell: ({ row }) => (
        <ExpandableChips
          items={row?.original?.devices?.map((device) => device?.deviceName)}
        />
      ),
    },
    {
      header: "Actions",
      accessorKey: "actions",
      enableColumnFilter: false,
      size: 80,
      enableSorting: false,
      accessorFn: (rowData) => {
        const devices = rowData?.devices?.map((device) => device?._id);
        return (
          <div style={{ display: "inline-flex" }}>
            <Tooltip header={"Edit"}>
              <EditOutlined
                className="editIcon"
                style={{ marginRight: "10px" }}
                onClick={() => {
                  setShowEditModal(true);
                  setIsEditMode(true);
                  setSelectedRow({ ...rowData, devices });
                }}
              />
            </Tooltip>

            {/* <Tooltip header={"Delete"}>
              <DeleteIcon
                className="deleteIcon"
                onClick={() => {
                  setShowConfirmModal(true);
                  setSelectedRow(rowData);
                }}
              />
            </Tooltip> */}
          </div>
        );
      },
    },
  ];

  return (
    <>
      {/* {showConfirmModal && (
        <ConfirmModal
          show={showConfirmModal}
          isConfirming={isDeleting}
          onConfirm={deleteDeviceGroups}
          onCancel={onConfirmModalClose}
        />
      )} */}
      {showEditModal && (
        <DeviceGroupModal
          show={showEditModal}
          isEditMode={isEditMode}
          selectedRow={selectedRow}
          onCloseModal={onCloseModal}
          selectorsData={selectorsData}
          fetchDeviceGroups={fetchDeviceGroups}
        />
      )}

      <CustomTable
        data={deviceGroups ?? []}
        columns={columns}
        options={{
          enableTopToolbar: true,
          enableSorting: true,
          state: {
            isLoading,
            showGlobalFilter: true,
            columnVisibility: {
              actions: !(userRole === USER_ROLES.CLINIC_ADMIN),
            },
          },
          muiSearchTextFieldProps: {
            placeholder: "Search Device Groups",
          },
          showRowsPerPage: false,
          renderTopToolbar: ({ table }) => (
            <Grid
              style={{
                display: "flex",
                gap: "10px",
                padding: "10px 15px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <GlobalFilterTextField
                table={table}
                props={{ placeholder: "Search Templates" }}
              />
              {userRole !== USER_ROLES.CLINIC_ADMIN && (
                <Button
                  onClick={() => {
                    setShowEditModal(true);
                    setIsEditMode(false);
                  }}
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                >
                  Add Device Group
                </Button>
              )}
            </Grid>
          ),
        }}
      />
    </>
  );
};

export default React.memo(DeviceGroupsView);
